import React from "react";

interface ITourismGuide {
  image: string;
  text: string;
}

const TourGuide: React.FC = () => {
  const tourGuideData: ITourismGuide[] = [
    {
      image: "/tourism/tourism-guide-1.png",
      text: "Spiritual Pilgrimages Made Accessible",
    },
    {
      image: "/tourism/tourism-guide-2.png",
      text: "Open-World Museums and Historical Parks",
    },
    {
      image: "/tourism/tourism-guide-3.png",
      text: "Enhancing Urban Exploration",
    },
    {
      image: "/tourism/tourism-guide-4.png",
      text: "Preserving and Showcasing Cultural Heritage",
    },
    {
      image: "/tourism/tourism-guide-5.png",
      text: "Educational Adventures for Students",
    },
    {
      image: "/tourism/tourism-guide-6.png",
      text: "A Companion for Individual Explorers",
    },
  ];

  return (
    <div className="">
      <div className="p-5">
        <h3 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl">
          Your Personal Tour Guide
        </h3>
        <p className="text-[#5B5F62] text-sm sm:text-base lg:text-xl xl:text-2xl pt-5 lg:pt-6 xl:pt-10 max-w-2xl">
          Our Tour Guide App is not just a tool; it's a transformative
          experience for diverse settings. Here's how it's redefining tourism
          and cultural exploration:
        </p>
      </div>
      <div className="pt-5 lg:pt-7 xl:pt-10 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5 xl:gap-10">
        {tourGuideData.map((data) => (
          <div
            key={data.text}
            className="text-[#2D3134] flex flex-col justify-center items-center font-bold lg:text-lg xl:text-2xl"
          >
            <div className="rounded-full ">
              <img src={data.image} alt={data.text} className="rounded-full" />
            </div>
            <p className="text-center pt-3 flex-1 max-w-48">{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourGuide;
